<template>
  <b-modal id="add-access-rule" ref="add-access-rule" title="New Access Rules" @ok="addAccessRule($event)" @hidden="resetModals"
           ok-title="Create" ok-variant="success" :ok-disabled="disableOkButton">
    <b-alert v-if="accessRuleError" show variant="danger">
      {{ accessRuleError }}
    </b-alert>
    <b-form>
      <b-form-group label="Please select a rule type" v-slot="{ ariaDescribedby }"
                    description="'Domain' grants access to all users with the specified email domain. 'User' only grants access to a specific user.">
        <b-form-radio-group
            id="radio-group-1"
            v-model="newAccessRuleGroup.rule_type"
            :options="ruleTypeOptions"
            :aria-describedby="ariaDescribedby"
            name="radio-options-rule-type"
        ></b-form-radio-group>
      </b-form-group>
      <b-form-group :label="newAccessRuleEmailLabel" label-for="access-rule-email">
        <b-form-input
            v-model="newAccessRuleGroup.email"
            :placeholder="newAccessRuleEmailHint"
            id="access-rule-email"
        />
      </b-form-group>
      <b-form-group
          label="Grant access"
          label-for="access-rules"
      >
        <div v-for="(access_rule, index) in newAccessRuleGroup.access_rules" :key="'access-rule-' + index" class="d-flex align-items-center mb-2">
          <b-form-input
              v-model="access_rule.access_machine_dealer"
              :placeholder="`Dealer`"
              list="dealerListId"
              class="mr-2"
              v-if="access_rule.access_machine_dealer !== undefined"
          />
          <b-form-input
              v-model="access_rule.access_machine_serial"
              :placeholder="`Machine Serial`"
              list="machineSerialListId"
              class="mr-2"
              v-if="access_rule.access_machine_serial !== undefined"
          />
          <b-button
              variant="danger"
              @click="removeAccessRule(index)"
          >
            Remove
          </b-button>
        </div>

        <datalist id="dealerListId">
          <option v-for="dealer in dealerList" :key="dealer">{{ dealer }}</option>
        </datalist>
        <datalist id="machineSerialListId">
          <option v-for="serial in machineSerials" :key="serial">{{ serial }}</option>
        </datalist>
      </b-form-group>
      <b-button variant="primary" size="sm" @click="addDealer">
        <font-awesome-icon icon="plus"/>
        Access by Dealer
      </b-button>
      <b-button variant="primary" size="sm" @click="addSerial" class="ml-2">
        <font-awesome-icon icon="plus"/>
        Access by Machine
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'AccessRulesModalAdd',
  data () {
    return {
      accessRuleError: null,
      newAccessRuleGroup: {
        'email': '',
        'rule_type': 'domain',
        'access_rules': [],
      },
      ruleTypeOptions: [
        { text: 'Domain', value: 'domain' },
        { text: 'User', value: 'user' },
      ],
      accessType: '',
    }
  },
  created () {
    this.$store.dispatch('loadDealers')
    this.$store.dispatch('loadMachineSerials')
  },
  computed: {
    ...mapGetters(['getDealers', 'getMachineSerials']),
    machineSerials () {
      return this.getMachineSerials
    },
    dealerList () {
      return this.getDealers?.map(dealer => dealer.name)
    },
    disableOkButton () {
      const group = this.newAccessRuleGroup

      if (!group?.email) return true

      const rules = group.access_rules || []
      if (rules.length === 0 || Object.keys(rules[0]).length === 0) return true

      return rules.every(rule => !rule.access_machine_serial && !rule.access_machine_dealer)
    },
    newAccessRuleEmailLabel () {
      if (this.newAccessRuleGroup.rule_type === 'domain') {
        return 'Email Domain'
      } else { // this.newAccessRuleGroup.rule_type === 'user'
        return 'Email Address'
      }
    },
    newAccessRuleEmailHint () {
      if (this.newAccessRuleGroup.rule_type === 'domain') {
        return 'Enter an access-rule email domain (eg. metso.com)'
      } else { // this.newAccessRuleGroup.rule_type === 'user'
        return 'Enter an access-rule email (eg. user@metso.com)'
      }
    },
  },
  methods: {
    show () {
      this.$refs['add-access-rule'].show()
    },
    async addAccessRule (event) {
      event.preventDefault()
      try {
        await this.$store.dispatch('addAccessRuleGroup', this.newAccessRuleGroup)
        this.$refs['add-access-rule'].hide()
        this.resetModals()
      } catch (error) {
        this.accessRuleError = 'Failed adding access rules. ' + error
      }
    },
    resetModals () {
      this.accessRuleError = null
      this.accessType = ''
      this.newAccessRuleGroup = {
        'email': '',
        'rule_type': 'domain',
        'access_rules': [],
      }
    },
    addDealer () {
      this.newAccessRuleGroup.access_rules.push({
        'access_machine_dealer': ''
      })
    },
    addSerial () {
      this.newAccessRuleGroup.access_rules.push({
        'access_machine_serial': ''
      })
    },
    removeAccessRule (index) {
      if (this.newAccessRuleGroup.access_rules.length >= 1) {
        this.newAccessRuleGroup.access_rules.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss">
</style>
